import Breadcrumb from './../components/BreadCrumb';
import HeadingDetailsSection from './../sections/HeadingDetailsSection';
import ServiceSection from './../sections/ServiceSections';

function TermsAndConditionsScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Terms And Conditions'>
          <Breadcrumb screen='Terms And Conditions'/>
        </HeadingDetailsSection>
        <ServiceSection/>
    </>
  );
}

export default TermsAndConditionsScreen;
